import React from 'react';
import Title from '../Components/Elements/Title';
import MainContainer from '../Components/Elements/MainContainer';
import Text from '../Components/Elements/Text';
import theOrchard from '../images/theOrchard.jpg';
import AdaptiveContainer from '../Components/Elements/AdaptiveContainer';
import { Helmet } from 'react-helmet';
import { useStore } from '../Stores/store';
import { UserType } from '../Models/UserType';
import { Link } from 'react-router-dom';

interface Props {
    useHelm?: boolean;
}

const About = ({ useHelm = false} : Props) => { 
    const { generalStore } = useStore();
    const { userType } = generalStore;

    return (
        <MainContainer>
            {useHelm && (
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>H&R Wedding | About</title>
                </Helmet>
            )}
            <Title size="3">About the big day</Title>
            <Text>After 9 years, we&apos;re getting married, and this website will provide you with all the information you will need so that you can also enjoy our special day!</Text>
            <Text>We&apos;re getting married at the Orchard in Maidstone</Text>
            {
                userType === UserType.DayGuest ? (
                    <Text>Guests may arrive from <b>12:30pm</b>. The ceremony will commence at <b>13:30</b>.</Text>
                ) : (
                    <Text>Guests may arrive from <b>19:00pm</b>.</Text>
                )
            }
            <Text><b>Address:</b> The Orchard, Spot Ln, Downswood, Maidstone ME15 8SE</Text>  
            <AdaptiveContainer>
                <div className="w-full">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2511.123456789!2d0.123456789!3d51.123456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x69ec60e56990aaf3!2sThe%20Orchard!5e0!3m2!1sen!2suk!4v1234567890"
                        className="w-full min-h-[200px] max-h-[350px] border-0"
                        allowFullScreen={true}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="The Orchard"
                    ></iframe>
                </div>
                <div className="flex justify-center items-center">
                    <img src={theOrchard} alt="The Orchard" className="w-full h-full"/>
                </div>
            </AdaptiveContainer> 

            <Title size="2">Parking</Title>
            <Text>There is a good amout of parking at the venue where guests may leave their parked cars overnight. Guests must pick their car up the following morning before <span className="text-red-400">10:00am</span></Text>
            { useHelm && <Text className="pt-4">
                <Link
                    to="/app"
                    className="bg-blue-500 hover:bg-blue-700 font font-lora text-white font-bold py-2 px-4 rounded my-2 inline-block text-center"
                >
                    Back to home
                </Link>
            </Text>}
        </MainContainer>
    )
};

export default About;